import React, { useState } from "react"

const VPNSelector = () => {
  const [loadingIndex, setLoadingIndex] = useState(null)

  const vpnOptions = [
    { name: "US AWS", url: "https://vpn-aws.kalypso.com", region: "US" },
    { name: "US Azure ", url: "https://vpn-azure.kalypso.com", region: "US" },
    { name: "EU Azure ", url: "https://vpn-azure-eu.kalypso.com", region: "EU" },
    { name: "Asia Azure ", url: "https://vpn-azure-asia.kalypso.com", region: "Asia" },
    { name: "GOV ", url: "https://vpn.kalypsogov.com", region: " GOV" },
  ]

  const handleSelection = (vpn, index) => {
    setLoadingIndex(index)
    setTimeout(() => {
      /*window.alert(You have been redirected to ${vpn.name});*/
      window.open(vpn.url, "_blank", "noopener,noreferrer")
      setLoadingIndex(null)
    }, 1000)
  }

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen bg-blue-500 text-white px-10">
      {/* Background Image */}
      <div className="absolute top-0 left-0 w-full h-full bg-[url('/company-logo.png')] bg-center bg-cover opacity-10 z-0"></div>

      {/* Main Card */}
      <div className="relative z-10 w-full max-w-5xl p-12 bg-white bg-opacity-10 backdrop-blur-lg rounded-3xl shadow-xl border border-white/20">
        <h1 className="text-4xl font-bold mb-8 text-center">Please choose VPN</h1>

        {/* Table */}
        <div className="overflow-x-auto w-full">
          <table className="w-full text-lg vpn-table">
            <thead>
              <tr>
                <th className="py-3 px-6">VPN Name</th>

                <th className="py-3 px-6">Actions</th>
              </tr>
            </thead>
            <tbody>
              {vpnOptions.map((vpn, index) => (
                <tr key={index} className="border-b border-gray-600">
                  <td className="py-4 px-6 text-left">{vpn.name}</td>

                  <td className="py-4 px-6 text-center">
                    <button onClick={() => handleSelection(vpn, index)} className="px-6 py-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold rounded-full shadow-md hover:shadow-xl transform hover:scale-105 transition-all duration-300">
                      {loadingIndex === index ? "Loading..." : "Connect"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default VPNSelector
